import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-sous-chapitre',
  templateUrl: './sous-chapitre.component.html',
  styleUrl: './sous-chapitre.component.scss'
})
export class SousChapitreComponent implements OnInit {

  exercice: number = new Date().getFullYear();

  chapitres: any[] = [];
  sousChapitres: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  selectedChapitre: any = null;
  item: any = {};

  @ViewChild('sousChapitreModal') sousChapitreModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadChapitres();
    this.loadData();
  }

  loadChapitres(): void {
    this.paramService.getBordereauChapitres({ annee: this.exercice }).subscribe(
      (response: any) => {
        this.chapitres = response.data || [];
      },
      (error: any) => {
        this.chapitres = [];
      }
    );
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauSousChapitres({
      annee: this.exercice,
      chapitre_id: this.selectedChapitre || ''
    }).subscribe(
      (response: any) => {
        this.sousChapitres = response.data || [];
        this.totalRecords = this.sousChapitres.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des sous-chapitres'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.sousChapitres.slice(this.first, this.first + this.rows);
  }

  openModal(item?: any) {
    this.item = item
      ? { ...item, chapitre_id: item.chapitre?.reference }
      : { chapitre_id: this.selectedChapitre, annee: this.exercice };
    this.modalService.open(this.sousChapitreModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  onParentChange() {
    const chapitre = this.chapitres.find(c => c.reference === this.item.chapitre_id);
    if (chapitre && !this.item.reference) {
      this.item.code = chapitre.code;
    }
  }

  save() {
    if (!this.item.chapitre_id || !this.item.code || !this.item.libelle) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez renseigner le chapitre, le code et le libellé'
      });
      return;
    }
    this.ngxService.start();
    const reference = this.item.reference;
    this.paramService.saveBordereauSousChapitre(this.item, reference).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }

  confirmSuppression(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer le sous-chapitre ' + item.libelle + ' ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramService.deleteBordereauSousChapitre(item.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.loadData();
          },
          (error: any) => {
            this.ngxService.stop();
            this.messageService.add({
              severity: 'error',
              summary: Constant.suiviTitle,
              detail: error?.error?.message || 'Une erreur est survenue'
            });
          }
        );
      }
    });
  }
}
